import React, { lazy, Suspense, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CollapsibleCard from '../../../../components/CollapsibleCard';
import { CardContent } from '../../../../components/ui/card';
import { UploadHistoryProvider, useUploadHistoryContext } from '../../../../contexts/UploadHistoryContext';
import TableSkeleton from '../../../../components/TableSkeleton';
import FiltersSkeleton from '../../../../components/FiltersSkeleton';
import FiltersSection from './FiltersSection';
import ViewDetails from './detailview/ViewDetails';
import ClusterModule from '../../../../layout/Cluster/ClusterModule';
import { loadClusterState } from '../../../../store/cluster/actions';

const TanstackTable = lazy(() => import('../../../../components/TanstackTable'));

const Content = () => {
    const dispatch = useDispatch();
    const [showClusterTooltip, setShowClusterTooltip] = useState(false);
    const { listLoading } = useSelector((state) => state.Uploads);
    
    const {
        table,
        columns,
        uploadLogs,
        handlePageChange,
        openViewLogModal,
        handleHideViewLogModal,
        viewUploadLogData,
        pagination,
    } = useUploadHistoryContext();

    useEffect(() => {
        dispatch(loadClusterState());
        let hideTimer;

        const showTimer = setTimeout(() => {
            setShowClusterTooltip(true);

            hideTimer = setTimeout(() => {
                setShowClusterTooltip(false);
            }, 5000); // hide after 5 seconds

            // Optional: clear hideTimer on cleanup
        }, 4000); // show after 4 seconds

        return () => {
            clearTimeout(showTimer);
            clearTimeout(hideTimer);
        };
    }, [dispatch]);
    
    return (
        <>
            <div className='flex justify-end mb-2'>
                <ClusterModule showTooltip={showClusterTooltip} />
            </div>
            <CollapsibleCard title="Upload History" className="bg-white bg-opacity-100">
                <CardContent className="p-0">
                    <Suspense fallback={<FiltersSkeleton />}>
                        <FiltersSection />
                    </Suspense>
                    {/* {loading ? (
                        <TableSkeleton 
                            columns={5} 
                            rows={5} 
                            headers={["#", "Key", "FileName", "Actions", "Project", "Status", "Source Type", "Uploaded On", "Uploaded By"]} 
                        />
                    ) : ( */}
                        <Suspense fallback={<TableSkeleton 
                            columns={5} 
                            rows={5} 
                            headers={["#", "Key", "FileName", "Actions", "Project", "Status", "Source Type", "Uploaded On", "Uploaded By"]} 
                        />}>
                            <TanstackTable
                                loading={listLoading}
                                table={table}
                                columns={columns}
                                pagination={pagination}
                                data={uploadLogs}
                                handlePageChange={handlePageChange}
                            />
                        </Suspense>
                    {/* )} */}
                </CardContent>
            </CollapsibleCard>
            {viewUploadLogData && (
                <ViewDetails
                    key={openViewLogModal ? "open" : "closed"}  // Forces re-render
                    open={openViewLogModal}
                    handleClose={handleHideViewLogModal}
                    data={viewUploadLogData}
                />
            )}
        </>
    );
};

const UploadHistory = () => (
    <UploadHistoryProvider>
        <Content />
    </UploadHistoryProvider>
);

export default UploadHistory;